import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private navigationTrigger: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public navigationTrigger$: Observable<string> = this.navigationTrigger.asObservable();
  constructor() {}

  setNavigationTrigger(navigationTrigger: string) {
    this.navigationTrigger.next(navigationTrigger);
  }
}
